module.exports = __webpack_public_path__ + "img/img0.1c32c119.jpg";